module.exports = __webpack_public_path__ + "static/media/schoolingMobile.de300a33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/schoolingMobile.jpg
// module id = 815
// module chunks = 12